import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticleCardsSection() {
  const displayArticles = articles.filter(a => a.slug !== "itaobuy-sheet-sourcing-guide");

  return (
    <section className="py-16 md:py-20 lg:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-3">
          <span className="w-2 h-2 rounded-full bg-primary-500"></span>
          <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
            SEO Sourcing Guides
          </span>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 leading-tight">
          Latest ItaobuySpreadsheet
          <br />
          Articles &amp; Guides
        </h2>
        <p className="text-sm text-foreground-500 mt-3 max-w-lg">
          Expert insights on product sourcing, price tracking, and e-commerce optimization
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 mt-10">
          {displayArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/articles/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-background-300/60 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.cardImage}
                  alt={article.cardAlt}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 text-[10px] font-medium text-foreground-600 bg-background-50/90 backdrop-blur-sm rounded-full">
                    {article.date}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 leading-relaxed line-clamp-2 flex-1">
                  {article.metaDescription}
                </p>
                <div className="flex items-center gap-1.5 mt-4 text-xs font-medium text-primary-500">
                  Read Article
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}